import React, { useState } from "react";
import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { useEnquirySiteVisitOverview } from "./EnquirySiteVisitOverviewContext";
import { runEnquirySiteVisitStart } from "../enquirySiteVisitWorkflow";
import EnquirySiteVisitWorkflowModals from "../EnquirySiteVisitWorkflowModals";
import { isTerminalSiteVisitStatus } from "../utils/siteVisitActionPolicy";
import { useProfile } from "features/Authentication/hooks/useProfile";
import { getSiteVisitWorkflowUiVisibility } from "../siteVisitWorkflowAccess";

const EnquirySiteVisitWorkflowActions = () => {
  const { isEmployee } = useProfile();
  const { enquirySiteVisit, refetch } = useEnquirySiteVisitOverview();
  const [busy, setBusy] = useState(false);
  const [completeOpen, setCompleteOpen] = useState(false);
  const [cancelOpen, setCancelOpen] = useState(false);

  if (!enquirySiteVisit) return null;

  const isTerminalStatus = isTerminalSiteVisitStatus(enquirySiteVisit.status);
  const { showStart, showComplete, showCancel, showAnyWorkflow } =
    getSiteVisitWorkflowUiVisibility(enquirySiteVisit.status, isEmployee);

  if (isTerminalStatus || !showAnyWorkflow) {
    return null;
  }

  const handleStart = async () => {
    if (!showStart) return;
    setBusy(true);
    try {
      const ok = await runEnquirySiteVisitStart(enquirySiteVisit.id);
      if (ok) await refetch();
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      {showStart ? (
        <Button
          type="button"
          color="primary"
          size="sm"
          disabled={busy}
          onClick={() => void handleStart()}
        >
          <i className="ri-play-circle-line align-bottom me-1" />
          Start visit
        </Button>
      ) : null}
      {showComplete ? (
        <Button
          type="button"
          color="success"
          size="sm"
          disabled={busy}
          onClick={() => setCompleteOpen(true)}
        >
          <i className="ri-checkbox-circle-line align-bottom me-1" />
          Complete visit
        </Button>
      ) : null}
      {showCancel ? (
        <UncontrolledDropdown>
          <DropdownToggle
            type="button"
            className="btn btn-light btn-sm border"
            disabled={busy}
          >
            <i className="ri-more-2-fill align-middle" />
          </DropdownToggle>
          <DropdownMenu end>
            <DropdownItem
              className="text-danger"
              onClick={() => setCancelOpen(true)}
            >
              <i className="ri-close-circle-line align-bottom me-2" />
              Cancel visit
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      ) : null}

      <EnquirySiteVisitWorkflowModals
        visitId={enquirySiteVisit.id}
        completeOpen={completeOpen}
        cancelOpen={cancelOpen}
        onCloseComplete={() => setCompleteOpen(false)}
        onCloseCancel={() => setCancelOpen(false)}
        onSuccess={() => refetch()}
      />
    </>
  );
};

export default EnquirySiteVisitWorkflowActions;
